import React, { createContext, useContext, useState, useEffect } from 'react'
import { tenantAPI } from '../lib/api'

const TenantContext = createContext(null)

function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result
    ? `${parseInt(result[1], 16)} ${parseInt(result[2], 16)} ${parseInt(result[3], 16)}`
    : null
}

function darkenHex(hex, amount = 15) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  if (!result) return hex
  const r = Math.max(0, parseInt(result[1], 16) - amount)
  const g = Math.max(0, parseInt(result[2], 16) - amount)
  const b = Math.max(0, parseInt(result[3], 16) - amount)
  return `${r} ${g} ${b}`
}

export function TenantProvider({ children }) {
  const [tenant, setTenant] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    tenantAPI.getConfig()
      .then(res => {
        setTenant(res.data)
        applyBranding(res.data?.branding)
      })
      .catch(() => setTenant(null))
      .finally(() => setLoading(false))
  }, [])

  return (
    <TenantContext.Provider value={{ tenant, loading, setTenant }}>
      {children}
    </TenantContext.Provider>
  )
}

function applyBranding(branding) {
  if (!branding) return
  const root = document.documentElement
  const colors = branding.colors || {}

  if (colors.primary) {
    const rgb = hexToRgb(colors.primary)
    if (rgb) {
      root.style.setProperty('--brand-primary-rgb', rgb)
      root.style.setProperty('--brand-primary-hover-rgb', darkenHex(colors.primary, 15))
    }
  }
  if (colors.secondary) {
    const rgb = hexToRgb(colors.secondary)
    if (rgb) root.style.setProperty('--brand-secondary-rgb', rgb)
  }
  if (colors.accent) {
    const rgb = hexToRgb(colors.accent)
    if (rgb) root.style.setProperty('--brand-accent-rgb', rgb)
  }
}

export function useTenant() {
  const context = useContext(TenantContext)
  if (!context) return { tenant: null, loading: false, setTenant: () => {} }
  return context
}
